import { VuexModule, Module, mutation /*, action*/, getter } from 'vuex-class-component';
import Nullable from '@/types/nullable';
import User from '@/models/user';

@Module()
export default class UserStore extends VuexModule {
  @getter public user: Nullable<User> = null;

  public get hasUserDetails(): boolean {
    return this.user != null;
  }

  public get displayName(): Nullable<string> {
    if(!this.user){
      return null;
    }

    return `${this.user.firstname} ${this.user.surname}`;
  }

  public get id(): Nullable<number> {
    if(!this.user){
      return null;
    }

    return this.user.id;
  }

  @mutation public setUser(user: User): void {
    this.user = user;
  }

  @mutation public clearUser(): void {
    this.user = null;
  }
}